import { StartTrainingModal } from 'modules/trainings/components/StartTrainingModal'

const StopTraining = () => {
  return <StartTrainingModal status={'draft'} />
}

export default StopTraining
